import { FC, useEffect, useState } from "react";
import { BsArrowUpCircleFill } from "react-icons/bs";
import './ScrollToTopComponent.css';

const ScrollToTopComponent: FC = () => {
  const [showButton, setShowButton] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setShowButton(window.scrollY > 200);
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return showButton ? (
    <button
      onClick={scrollToTop}
      className="scroll-to-top-btn position-fixed btn btn-primary rounded-5 border-2 border-white shadow d-flex align-items-center justify-content-center"
      title="Yukarı çık"
    >
      <BsArrowUpCircleFill size={28} color="white" />
    </button>
  ) : null;
};

export default ScrollToTopComponent;
